export const beersActions = {
  load: 'beers@load',
  add: 'beers@add',
  update: 'beers@update',
  delete: 'beers@delete',
};
